<template>
  <v-dialog :value="value" @input="$emit('input', $event)" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ isEditing ? 'Checkliste bearbeiten' : 'Neue Checkliste' }}</span>
      </v-card-title>
      <v-card-text>
        <p v-if="!isEditing && vehicleName">
          Checkliste wird hinzugefügt in Fahrzeug: <strong>{{ vehicleName }}</strong>
        </p>
        <v-text-field v-model="data.title" label="Name der Checkliste" required outlined></v-text-field>
        <v-text-field v-if="isEditing" v-model="data.sorter" label="Sortierung" outlined></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Abbrechen</v-btn>
        <v-btn color="primary" text @click="onSave">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const defaultData = { title: '', sorter: '0' };

export default {
  name: "ChecklistDialog",
  props: {
    value: { type: Boolean, required: true },
    isEditing: { type: Boolean, default: false },
    checklistData: { type: Object, default: () => ({...defaultData}) },
    vehicleName: { type: String, default: '' }
  },
  data() {
    return {
      data: {...defaultData}
    };
  },
  watch: {
    value: {
      handler(isOpen) {
        if (isOpen) {
          this.data = this.isEditing ? { ...this.checklistData } : { ...defaultData };
        }
      },
      immediate: true
    }
  },
  methods: {
    onSave() {
      this.$emit('save', this.data);
      this.$emit('input', false);
    }
  }
}
</script>